// extracted by mini-css-extract-plugin
export default {"submitWrapper":"CustomerInformationForm-module__submitWrapper___3fLRc AccountPage-module__submitWrapper___kQgng"};